import { IMemberProfile } from '../../interfaces/iMemberProfile'
import { ICause } from '../../interfaces/iCause'
import { IGeneralInfoOfMember } from '../../interfaces/iGeneralInfoOfMember'
import { ILocation } from '../../interfaces/iLocation'
import { ICompany } from '../../interfaces/iCompany'
import { INetwork } from "../../interfaces/iNetwork";
import { ISchool } from "../../interfaces/ISchool";
import { IPhilanthropy } from "../../interfaces/IPhilanthropy";
import { ICurrentPositions } from "../../interfaces/ICurrentPositions";
import { INonprofit } from "../../interfaces/iNonprofit";
import { GeneralInfoOfMember } from "../generalInfoOfMember";
import { IOrganization } from "../../interfaces/iOrganization";
import { IMetropolitanArea } from "../../interfaces/iMetropolitanArea";
import { IKeyName } from "../../interfaces/IKeyName";
import { CurrentStatuses } from '../../../components/dashboard/components/mainPanel/components/currentAccountStatus/enums/currentStatuses'
import { IOpportunity } from '../../interfaces/nonprofitProfile/iOpportunity';

export class DefaultMemberProfileData implements IMemberProfile {
    isMyProfile: boolean;
    philanthropy: IPhilanthropy[];
    currentPositions: ICurrentPositions[];
    fandoms: INonprofit[];
    generalInfo: IGeneralInfoOfMember;
	locations: ILocation[];
    metropolitanAreas: IMetropolitanArea[] = [];
    filterMetropolitanAreas: IMetropolitanArea[] = [];
    causes: ICause[];
    companies: ICompany[];
    network: INetwork;
    schools: ISchool[];
    subtypOpportunitiesList: IKeyName[];
    eventTypes: IKeyName[];
    prefTypes: IKeyName[];
    shortlistOpportunitiesList: IOpportunity[];
    constructor(memberProfile: IMemberProfile = {
        causes: [],
        isMyProfile: false,
        generalInfo: new GeneralInfoOfMember({
            firstName: "",
            lastName: "",
            role:"Position",
            imgUrl: require('../../../../images/memberProfile/defaultMemberImage.png'),
            key: "",
            bio: "",
            name: "Name",
            quote: "",
			quoteCredit: "",
            organization: {} as IOrganization,
            matchingStatus:  CurrentStatuses.Matching,
	        pausedUntilDate: new Date(),
            isAdmin: 0
        }),
        companies: [],
        network: {},
        currentPositions: [],
        locations: [],
        philanthropy: [],
        schools: []
    } as IMemberProfile) {
        this.isMyProfile = memberProfile.isMyProfile;
        this.generalInfo = memberProfile.generalInfo;
		this.locations = memberProfile.locations;
        this.metropolitanAreas = memberProfile.metropolitanAreas;
        this.filterMetropolitanAreas = memberProfile.filterMetropolitanAreas;
        this.causes = memberProfile.causes;
        this.companies = memberProfile.companies;
        this.network = memberProfile.network;
        this.schools = memberProfile.schools;
        this.philanthropy = memberProfile.philanthropy;
        this.currentPositions = memberProfile.currentPositions;
        this.subtypOpportunitiesList = this.subtypOpportunitiesList;
        this.eventTypes = this.eventTypes;
        this.prefTypes = this.prefTypes;
        this.shortlistOpportunitiesList = this.shortlistOpportunitiesList;
    }
    
    
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/memberProfile/defaultMemberProfileData.ts